import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import InfiniteScroll from 'react-infinite-scroll-component';

import moment from 'moment';

import Node from '../../common/Node';
import Search from '../../common/Search';
import Loader from '../../common/Loader';
import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';
import AutocompleteSelect from '../../common/AutocompleteSelect';

import { Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import {
  getUrlParameter,
  setUrlParameter,
  getAllRstsAsArray,
  getAllRstsAsObject,
  removeUrlParameter,
} from '../../utils';

import ActionConfirmation from '../../common/ActionConfirmation';

const styles = {
  ...CommonStyles,
};

class TrplsPage extends ComponentWrapper {
  state = {
    setupRestrictions: {},
    restrictionsOptions: [],
    nodes: {},
    trpls: {},
    pid: null,
    notFound: false,
    deleteTrplModal: {
      isOpened: false,
    },
    sid: null,
    oid: null,
    items: 50,
    loaded: false,
  };

  componentDidMount() {
    document.title="Triples | Milkyweb";

    this.prepareData();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (JSON.stringify(prevProps.light_meta_and_ops) !== JSON.stringify(this.props.light_meta_and_ops)) {
      this.prepareData();
    }
  };

  prepareData() {
    const { light_meta_and_ops } = this.props;

    const pid = getUrlParameter('pid');
    const sid = getUrlParameter('sid');
    const oid = getUrlParameter('oid');
    const restrictionsOptions = [];
    const allRstsAsArray = getAllRstsAsArray(light_meta_and_ops);
    const allRstsAsObject = getAllRstsAsObject(light_meta_and_ops);

    for (const rst of allRstsAsArray) {
      restrictionsOptions.push({
        label: `[${rst.id}] ${rst.title}`,
        value: rst.id,
      });
    }

    if (pid || sid || oid) {
      if (JSON.stringify(light_meta_and_ops) === '{}') return;

      this.get({
        url: `/get_trpls?${pid ? `pid=${pid}` : ''}${sid ? `&sid=${sid}` : ''}${oid ? `&oid=${oid}` : ''}`,
        cb: (trplsData) => {
          const { setup } = this.props;
          const notFound = !Object.keys(trplsData.trpls).length;

          const nodes = [];

          if (sid) nodes.push(sid);
          if (oid) nodes.push(oid);

          const data = {
            nesting: 1,
            api_key: setup.id,
            filter: {
              nodes,
            }
          };

          const nodesData = {};

          this.postWithData({
            url: `/pnkqry3`,
            data,
            cb: (res) => {
              if (sid) nodesData.sid = res.nodes[sid];
              if (oid) nodesData.oid = res.nodes[oid];

              const data = {
                ...nodesData,
                loaded: true,
                nodes: trplsData.nodes,
                trpls: trplsData.trpls,
                notFound,
              };

              if (pid) {
                data.pid = {
                  label: allRstsAsObject[pid] ? '[' + pid + '] ' + allRstsAsObject[pid].title : `Can't find pid`,
                  value: +pid
                };
              }

              this.setState(data);
            }
          });
        }
      });
    } else {
      this.setState({ loaded: true });
    }

    this.setState({
      restrictionsOptions,
      setupRestrictions: allRstsAsObject,
    });
  };

  onRstSelectChange = (option) => {
    if (option) {
      setUrlParameter('pid', option.value);
      this.setState({ pid: option }, () => {
        this.onSearchSubmit();
      });
    } else {/*pressed clear selection*/
      removeUrlParameter('pid');
      this.setState({ pid: null }, () => {
        this.onSearchSubmit();
      });
    }
  };

  onSearchSubmit = () => {
    const { sid, oid, pid } = this.state;

    if (!sid && !oid && !pid) {
      this.clearInputsAndResult();
      return;
    }

    this.setState(
      {
        loaded: false,
      },
      () => {
        this.get({
          url: `/get_trpls?${
            pid && pid.value ? `pid=${pid.value}` : ''}${
            sid ? `&sid=${sid.id}` : ''}${
            oid ? `&oid=${oid.id}` : ''}`,

          cb: (data) => {
            const notFound = !Object.keys(data.trpls).length;

            this.setState({
              nodes: data.nodes,
              trpls: data.trpls,
              loaded: true,
              notFound,
            });
          },
        });
      }
    );
  };

  toggleDeleteTrplModal = (isOpened, trpl) => {
    const { deleteTrplModal } = this.state;

    deleteTrplModal.isOpened = isOpened;
    deleteTrplModal.trpl = trpl;

    this.setState({ deleteTrplModal });
  };

  removeTrpl = () => {
    const { trpl } = this.state.deleteTrplModal;
    const { trpls } = this.state;

    this.get({
      url: `/rest/del_trpl?id=${trpl.tid}`,
      cb: () => {
        if (trpl.pid && trpls[trpl.pid]) {
          for (let i in trpls[trpl.pid])
            if (trpls[trpl.pid][+i].tid === trpl.tid) trpls[trpl.pid].splice(+i, 1);
        }

        this.setState({ trpls });

        this.toggleDeleteTrplModal(false);
      },
    });
  };

  onSearchElClick = (type, nodeProps) => {
    setUrlParameter(type, nodeProps.node.id);

    this.setState({ [type]: nodeProps.node }, () => {
      this.onSearchSubmit();
    });
  };

  clearInputsAndResult = () => {
    removeUrlParameter('sid');
    removeUrlParameter('pid');
    removeUrlParameter('oid');
    this.setState({ pid: null, sid: null, oid: null, trpls: {} });
  };

  setDefaultItems = () => {
    this.setState({ items: 50 });
  }

  fetchMoreData = () => {
    this.setState({ items: this.state.items + 50 });
  };

  getTrplsChunk = () => {
    const { trpls, items } = this.state;

    let trplsChunk = [];
    if (!trpls) return trplsChunk;

    for (const rid of Object.keys(trpls)) {
      if (trplsChunk.length >= items) break;
      trplsChunk.push(...trpls[rid].slice(0, items - trplsChunk.length));
    }

    return trplsChunk;
  };

  render() {
    const { classes } = this.props;
    const {
      pid,
      sid,
      oid,
      trpls,
      nodes,
      items,
      loaded,
      notFound,
      deleteTrplModal,
      setupRestrictions,
      restrictionsOptions,
    } = this.state;

    let totalTrplsNumber = 0;
    Object.keys(trpls).forEach(rid => totalTrplsNumber += trpls[rid].length);

    const trplsChunk = this.getTrplsChunk();
    const hasMoreData = totalTrplsNumber > trplsChunk.length;

    return (
      <div className={classes.container}>
        <ActionConfirmation
          modalData={{
            open: deleteTrplModal.isOpened,
            contentText: "Delete Triple",
            contentBoldText: `${deleteTrplModal.trpl && deleteTrplModal.trpl.tid}?`,
          }}
          acceptHandler={this.removeTrpl}
          onClose={() => this.toggleDeleteTrplModal(false)}
        />

        <div
          style={{
            display: 'flex',
            padding: '10px',
            background: '#fff',
            marginBottom: '20px',
            alignItems: 'flex-end',
          }}
        >
          <div style={{ width: '222px', flexShrink: '0' }} className={classes.mr20}>
            <div style={{ paddingBottom: '5px' }}>Subject</div>
            {sid ? (
              <Node
                isLink
                isRemovable
                onRemoveClick={() => {
                  removeUrlParameter('sid');
                  this.setDefaultItems();
                  this.setState({ sid: null }, () => {
                    this.onSearchSubmit();
                  });
                }}
                size="md"
                node={sid}
                nodeId={sid.id}
                nodes={nodes}
              />
            ) : (
              <Search
                containerStyles={{
                  height: '38px',
                }}
                onDropdownElementClick={(nodeProps) => this.onSearchElClick('sid', nodeProps)}
              />
            )}
          </div>

          <div className={`${classes.flex} ${classes.fw} ${classes.mr20}`}>
            <AutocompleteSelect
              style={{
                marginBottom: '1px',
                marginRight: '10px',
                width: '100%',
              }}
              value={pid || ''}
              options={restrictionsOptions}
              onChange={(option) => {
                this.setDefaultItems();
                this.onRstSelectChange(option);
              }}
            />
          </div>

          <div style={{ width: '222px', flexShrink: '0', marginRight: '20px' }}>
            <div style={{ paddingBottom: '5px' }}>Object</div>
            {oid ? (
              <Node
                isLink
                isRemovable
                onRemoveClick={() => {
                  removeUrlParameter('oid');
                  this.setDefaultItems();
                  this.setState({ oid: null }, () => {
                    this.onSearchSubmit();
                  });
                }}
                size="md"
                node={oid}
                nodeId={oid.id}
                nodes={nodes}
              />
            ) : (
              <Search
                containerStyles={{
                  height: '38px',
                }}
                onDropdownElementClick={(nodeProps) => this.onSearchElClick('oid', nodeProps)}
              />
            )}
          </div>

          <Button
            size="medium"
            color="secondary"
            variant="contained"
            onClick={() => {
              this.setDefaultItems();
              this.clearInputsAndResult();
            }}
          >
            Clear
          </Button>
        </div>

        <div>
          {!loaded ? (
            <div className={classes.justifyCenter}>
              <Loader />
            </div>
          ) : (
            <div>
              {notFound ? (
                <h2>Trpls for this filters not created yet</h2>
              ) : trplsChunk.length ? (
                <div>
                  <div style={{ width: '182px', marginLeft: '10px' }}>
                    {`Total triples number: ${totalTrplsNumber}`}
                  </div>
                  <InfiniteScroll
                    dataLength={items}
                    next={this.fetchMoreData}
                    hasMore={hasMoreData}
                    loader={
                      hasMoreData &&
                      <div className={classes.loaderContainer}>
                        <Loader />
                      </div>
                    }
                    style={{overflow: 'hidden'}}
                  >
                    <Table>
                      <TableHead>
                          <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Subject</TableCell>
                            <TableCell>Predicate</TableCell>
                            <TableCell>Value / Object</TableCell>
                            <TableCell>Update time</TableCell>
                            <TableCell>Delete</TableCell>
                          </TableRow>
                      </TableHead>

                      <TableBody>
                        {trplsChunk.map((trpl, trplIndex) => {
                          return (
                            <TableRow key={trplIndex}>
                              <TableCell style={{ width: '2%' }}>{`${trplIndex + 1}`}
                              </TableCell>

                              <TableCell style={{ width: '25%' }}>
                                <Node nodeId={trpl.sid}
                                      size="md"
                                      isLink
                                      node={nodes[trpl.sid]}
                                      nodes={nodes}
                                />
                              </TableCell>

                              <TableCell style={{ width: '15%' }}>{`[${trpl.pid}] ${
                                setupRestrictions[trpl.pid] ? setupRestrictions[trpl.pid].title : ''
                              }`}</TableCell>

                              <TableCell style={{ width: '48%', wordBreak: 'break-all' }}>
                                {trpl.type === 'OBJECT' ? (
                                  <Node nodeId={trpl.oid}
                                        size="md"
                                        isLink
                                        node={nodes[trpl.oid]}
                                        nodes={nodes}
                                  />
                                ) : (
                                  trpl && trpl.hasOwnProperty('val') && trpl.val !== null ? trpl.val : <em>no value</em>
                                )}
                              </TableCell>

                              <TableCell className={classes.nowrap} style={{ width: '5%' }}>{
                                moment(trpl.upd_time).format('DD/MM/YYYY HH:mm')}
                              </TableCell>

                              <TableCell style={{ width: '5%' }}>
                                <Button
                                  size="small"
                                  color="secondary"
                                  variant="contained"
                                  onClick={() => {
                                    this.toggleDeleteTrplModal(true, trpl);
                                  }}
                                >
                                  Delete
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </InfiniteScroll>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  setup: state.meta.setup,
  light_meta_and_ops: state.meta.light_meta_and_ops,
}))(withStyles(styles)(TrplsPage));
